import React  from 'react'
import LookupItemService from '../Services/LookupItemService';


class LookupText extends React.Component 
{

    static defaultProps={
        lookupId:23,
        valueArray: ["12"],
    };

    constructor(props) 
    {
        super(props);
        this.state = {
            text:""
        };
    }

    componentDidMount() 
    {
        LookupItemService.GetLookupItemByLookupIdAndLookupValueArray(this.props.lookupId, this.props.valueArray)
        .then(result=>this.setState({text:result.text}))
        .catch(error=>this.setState({text:""}));
    }

    render()
    {
        return this.state.text ;
    }
}


export default LookupText;
